import useWingitnorthListLocationGuestKpis, {
  wingitnorthListLocationGuestKpisConfigs,
} from './useListLocationGuestKpis'

export const configs = {
  wingitnorthListLocationGuestKpis: wingitnorthListLocationGuestKpisConfigs,
}

export const api = {
  wingitnorthListLocationGuestKpis: useWingitnorthListLocationGuestKpis,
}
